const mediaItems = [
  {
    id: 1,
    title: '最新院线大片合集',
    desc: '高清画质不缓冲，尽享影院级观影体验',
    tag: '电影在线观看',
    views: '12.8万',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20scene%20with%20warm%20golden%20theater%20lighting%20and%20dramatic%20film%20grain%20texture%2C%20abstract%20silhouette%20figures%20in%20cinema%20seats%2C%20elegant%20dark%20atmosphere%20with%20soft%20glow%2C%20professional%20film%20aesthetic%2C%20movie%20poster%20style%20composition&width=800&height=450&seq=media-card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '热播电视剧追剧专区',
    desc: '每日更新，热门剧集免费畅看',
    tag: '电视剧免费',
    views: '9.6万',
    img: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20living%20room%20scene%20with%20large%20screen%20displaying%20drama%20series%2C%20soft%20evening%20lighting%2C%20comfortable%20atmosphere%2C%20binge%20watching%20aesthetic%2C%20cinematic%20shot%20with%20warm%20tones%2C%20cozy%20home%20entertainment%20vibe&width=800&height=450&seq=media-card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '热门综艺高清合集',
    desc: '全网热门综艺节目一网打尽',
    tag: '综艺节目',
    views: '8.3万',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20variety%20show%20stage%20with%20colorful%20dynamic%20lighting%20design%2C%20professional%20television%20studio%20atmosphere%2C%20entertaining%20performance%20scene%2C%20bright%20and%20energetic%20composition%2C%20modern%20broadcast%20aesthetic%20with%20warm%20spotlights&width=800&height=450&seq=media-card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '91电影视频精选',
    desc: '海量影视视频，精彩不断更新',
    tag: '91电影视频',
    views: '15.2万',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20film%20collection%20display%20with%20floating%20movie%20posters%20in%20warm%20golden%20ambient%20light%2C%20abstract%20cinematic%20backdrop%20with%20soft%20bokeh%20effects%2C%20premium%20entertainment%20aesthetic%2C%20rich%20dark%20tones%20with%20amber%20highlights&width=800&height=450&seq=media-card-04&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              精彩视频
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              精选热门影视内容，高清流畅不缓冲
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {mediaItems.map((item) => (
              <article key={item.id} className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer">
                <div className="relative aspect-video overflow-hidden bg-background-200">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                  <div className="absolute top-3 left-3">
                    <span className="px-2 py-1 text-xs font-medium text-background-50 bg-accent-500/90 rounded-md">
                      {item.tag}
                    </span>
                  </div>
                  <div className="absolute bottom-3 left-3 flex items-center gap-1 text-background-50">
                    <i className="ri-eye-line text-sm w-4 h-4 flex items-center justify-center"></i>
                    <span className="text-xs">{item.views}</span>
                  </div>
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
                      <i className="ri-play-fill text-xl text-background-50"></i>
                    </div>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-1">{item.title}</h3>
                  <p className="text-xs text-foreground-500">{item.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}